import type { TextFieldProps } from '@flex-design-system/fx';
import { TextField } from '@flex-design-system/fx';
import { PencilRulerIcon } from '@flex-design-system/legacy-flex-icons';
import { Translation, useTranslation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';

type Props = Omit<TextFieldProps, 'type' | 'variant' | 'label'>;

const WorkExperienceJobRoleNameInput = ({ helperText, ...props }: Props) => {
  const { t } = useTranslation();

  return (
    <TextField
      type="text"
      variant="solid"
      placeholder={t(
        trans('recruiting.work_experience.job_role.edit.placeholder')
      )}
      label={
        <TextField.Label leftSlot={<PencilRulerIcon />}>
          <Translation tKey={trans('recruiting.work_experience.job_role')} />
        </TextField.Label>
      }
      helperText={<TextField.HelperText>{helperText}</TextField.HelperText>}
      {...props}
    />
  );
};

export default WorkExperienceJobRoleNameInput;
